<template>
    <div :class="$style.root">
        <div class="high-box">
            <a-spin :spinning="spinning">
                <div class="spin-content">
                    <newVideoView :video-recommendedlist="serachList" />

                    <div class="pagination-box">
                        <a-pagination
                            v-model="current"
                          
                            :total="serachExtra"
                            :show-total="serachExtra => `共 ${serachExtra} 条`"
                                :page-size="pageSize"
                      
                            @change="hotOnTableChanged">
                            <template slot="buildOptionText" slot-scope="props">
                                <span v-if="props.value !== '50'">{{ props.value }}条/页</span>
                                <span v-if="props.value === '50'">全部</span>
                            </template>
                        </a-pagination>
                    </div>
                </div>
            </a-spin>
        </div>
    </div>
</template>

<script>
    import { mapActions, mapState } from 'vuex';
    import newVideoView from '../../components/newVideoView.vue';

    export default {
        inject: ['bus'],
        name: 'Search',

        components: { newVideoView },
        data() {
            return {
                pageSizeOptions: ['12', '20', '30', '40', '50'],
                current: 1,
                pageSize: 12,
                spinning: true,
                media_name: '',
            };
        },
        computed: {
            ...mapState(['userInfo']),
            ...mapState('serach', [
                'serachList',
                'serachExtra',
            ]),
        },
        watch: {
            media_name() {
                const { media_name } = this;
                this.handNewRecommendedList({
                    currPage: this.current,
                    perPageNum: this.pageSize,
                    mediaName: media_name,
                });
            },
        },
        mounted() {
            this.bindEvent();
            const { keywords } = this.$route.params;
            this.handNewRecommendedList({
                currPage: this.current,
                perPageNum: this.pageSize,
                mediaName: keywords,
            });
        },
        methods: {
            ...mapActions('serach', ['getNewVideoList']),

            handNewRecommendedList(queries) {
                const orgId = this.userInfo.org_id || '';
                const queries1 = {
                    orgId: orgId || '',
                    ...queries,
                    orderType: 3
                };
                if (!this.userInfo.org_id) {
                    delete queries1.orgId;
                }
                
                this.getNewVideoList(queries1)
                    .then(() => {
                        this.spinning = false;
                    })
                    .catch(({ message }) => {
                        if (message) this.$message.error(message);
                    });
            },

            hotOnTableChanged(currPage, perPageNum) {
                const { keywords } = this.$route.params;
                const queries = {

                    currPage,
                    perPageNum,
                    mediaName: keywords,
                };

                this.handNewRecommendedList(queries);
            },
            bindEvent() {
                this.bus.$on('keywords', (val) => {
                    this.media_name = val.keywords;
                });
            },
        },
    };
</script>

<style lang="less" module>
    .root {
        min-width: 1200px;
        margin: auto;
        background: #f0f3f9;
        padding-top: 20px;
        display: flex;
        flex-direction: column;
        margin-top: 20px;

        :global {
            .spin-content {
                margin: auto;
                width: 1200px;
                padding-bottom: 50px;
                // padding-top: 50px;
                display: flex;
                flex-direction: column;
                justify-content: center;

                .pagination-box {
                    margin: auto;
                }
            }
        }
    }
</style>
